var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-row justify-between os-template-config"},[_c('labeled-item-list',{attrs:{"labeled-items":_vm.firstSet}}),_c('labeled-item-list',{attrs:{"labeled-items":_vm.secondSet}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }